import AbstractAPI from '@/services/api/AbstractAPI';

export default class RegistrationJourneyAPI extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/registration-journey');
  }

  status() {
    return this.makeRequest('/', 'get');
  }

  completeStep(stepNumber) {
    return this.makeRequest(`/complete/${stepNumber}`, 'put');
  }

  skipStep() {
    return this.makeRequest(`/skip`, 'put');
  }
}
